








































































import {
  defineComponent,
  Ref,
  ref,
} from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import GroupAddressEditor from '@/components/LocationAddress/GroupAddressEditor.vue';
import CommonPanelWithExpandable from '@/components/CommonPanelWithExpandable.vue';
import CommonTimePicker from '@/components/CommonTimePicker.vue';
import CommonAreaCodeSelector from '@/components/Setting/CommonAreaCodeSelector.vue';
import CommonUnitSelector from '@/components/Delivery/CommonUnitSelector.vue';

import uploadDeliveryCsv from '@/gql/delivery/uploadDeliveryCsv.gql';
import uploadDeliveryCsvLeased from '@/gql/delivery/uploadDeliveryCsvLeased.gql';

const ImportCSV = defineComponent({
  components: {
    CommonModalWithPreset,
    GroupAddressEditor,
    CommonPanelWithExpandable,
    CommonTimePicker,
    CommonAreaCodeSelector,
    CommonUnitSelector,
  },
  setup() {
    const deliveryType = ref('NORMAL');
    const successModal = ref(null);
    const errorModal = ref(null);
    const uploadDeliveryCsvMutation = useMutation(uploadDeliveryCsv, {
      context: {
        hasUpload: true,
      },
    });
    const errorCodes: Ref<any> = ref([]);

    const totalDupOrder: Ref<any> = ref(0);
    uploadDeliveryCsvMutation.onDone((result: any) => {
      // const deliveryId: Ref<any> = ref([]);
      if (result.data.uploadDeliveryCsv.success) (successModal.value as any).compose({ action: 'นำเข้า', entity: 'บิลล์' });
      else errorCodes.value = result.data.uploadDeliveryCsv.errors;
    });

    const uploadDeliveryCsvLeasedMutation = useMutation(uploadDeliveryCsvLeased, {
      context: {
        hasUpload: true,
      },
    });
    uploadDeliveryCsvLeasedMutation.onDone((result: any) => {
      // const deliveryId: Ref<any> = ref([]);
      if (result.data.uploadDeliveryCsvLeased.success) (successModal.value as any).compose({ action: 'นำเข้า', entity: 'บิลล์' });
      else errorCodes.value = result.data.uploadDeliveryCsvLeased.errors;
    });

    return {
      deliveryType,
      uploadDeliveryCsvMutation,
      uploadDeliveryCsvLeasedMutation,
      errorCodes,

      successModal,
      errorModal,

      totalDupOrder,
    };
  },
});

export default ImportCSV;
